module.exports = __webpack_public_path__ + "img/4.fd595ef7.jpg";